import { Component } from '@theme/component';

/**
 * IT PDP — detail accordions.
 *
 * Each row is a native <details> inside Horizon's <accordion-custom>, so
 * opening, closing, the height animation and keyboard handling need no
 * script and work before this module loads. The one thing left here is
 * the "only one row open" option, which closes the other rows when one
 * opens.
 */
class ItPdpDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('toggle', this.#onToggle, { capture: true });
  }

  /** @param {Event} event */
  #onToggle = (event) => {
    if (this.dataset.singleOpen !== 'true') return;

    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

    for (const other of this.querySelectorAll('details.it-det[open]')) {
      if (other !== opened) other.open = false;
    }
  };
}

if (!customElements.get('it-pdp-details')) {
  customElements.define('it-pdp-details', ItPdpDetails);
}
